module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA30lEQVQ4T42TvQ2DMBCF77mlCCNQG6RkhGQCMkJWySbZIGyQZINU1IxAGso7dChCYPyDO1t+n967H1hrb8aYmpnvbdt+acex1p4APImoR1mWDYBaL8x8SUFUbIx5EVFORD8URZFnWfYGcExBXDEzn6GO90B8YnU7AVKQkFh1MyAE0fdlZrW9rNMK4IP8DU4Fc8UbB4E4+uwVBwFOZv0XbPEmglswEeliLV4BfNUehqGLzckMiLUqNicTICZOzQn2iGMQVFXVE9Eh1qrlgjpxPrqNusK5iFxTm+g4eYhIMwIJPN1TWTsTjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/close.png
// module id = smv8
// module chunks = 489